import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import { ScrollSmoother } from "gsap/all";
import { SplitText } from "gsap/all";

document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

  let smoother = ScrollSmoother.create({
    wrapper: "#smooth-wrapper",
    content: "#smooth-content",
    smooth: 2,
    smoothTouch: 0.1,
  });

  gsap.set(".about-split", { opacity: 1 });
  SplitText.create(".about-split", {
    type: "words,lines",
    linesClass: "line",
    autoSplit: true,
    mask: "lines",
    onSplit: (self) => {
      gsap.from(self.lines, {
        duration: 0.6,
        yPercent: 100,
        opacity: 0,
        stagger: 0.1,
        ease: "expo.out",
        scrollTrigger: {
          trigger: ".about-box",
          start: "top 50%",
          end: "bottom 20%",
          toggleActions: "play none none none",
          // markers: true,
        },
      });
    },
  });
  const aboutMeTextBoxText = this.documentElement.querySelectorAll(
    ".about-me-text-box-text"
  );

  aboutMeTextBoxText.forEach((element) => {
    let split = SplitText.create(element, {
      type: "words, chars",
    });

    gsap.from(split.chars, {
      y: 100,
      autoAlpha: 0,
      stagger: 0.05,
      scrollTrigger: {
        trigger: ".about-me-text-image-container",
        start: "top 50%",
        end: "bottom 20%",
        toggleActions: "play none none none",
        // markers: true,
      },
    });
  });
});

const AboutContainer = document.querySelector(".about-box");

const options = {
  root: null,
  threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
};

function callback(entries) {
  entries.forEach((entry) => {
    const opacityRatio = 1.1 - entry.intersectionRatio;
    console.log(opacityRatio);
    if (entry.isIntersecting) {
      document.documentElement.style.setProperty("--opa", `${opacityRatio}`);
      document.documentElement.style.setProperty("--hero-back", opacityRatio);
    }
  });
}

const observer = new IntersectionObserver(callback, options);

observer.observe(AboutContainer);
